import React from "react";

type SectionHighlightProps = {
  title: string;
  subtitle?: string;
  maxItems?: number;
  children: React.ReactNode;
  isEmpty?: boolean;
};

/**
 * Componente per sezioni di evidenza (Oggi, Prossimi 7gg, Prossimi 30gg, ecc.)
 * Mostra un titolo, sottotitolo opzionale e contenuto.
 * Se isEmpty è true, non renderizza nulla.
 */
export function SectionHighlight({
  title,
  subtitle,
  children,
  isEmpty = false,
}: SectionHighlightProps) {
  if (isEmpty) return null;

  return (
    <section className="section-highlight">
      <header className="section-header">
        <h2 className="section-title-quicksand">{title}</h2>
        {subtitle && <p className="section-subtitle">{subtitle}</p>}
      </header>
      <div className="section-content">{children}</div>
    </section>
  );
}
